var exports = {
  "Dn": "checkIconColor__ZWoSWG",
  "TU": "infoPane__iByC3W",
  "nf": "link__pTJR2O",
  "R_": "heading__g8T3uK",
};

module.exports = exports;
